<template>
  <div
    id="accept-data-policy"
    class="
      h-screen
      flex
      w-full
      bg-img
      vx-row
      no-gutter
      items-center
      justify-center
    "
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/login.png"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <form
                class="p-8 login-tabs-container"
                @submit.prevent="requestReset"
              >
                <div class="vx-card__title">
                  <h4 class="pb-4">Datenschutz</h4>
                  <p>
                    Damit wir für Sie aktiv werden können und Ihnen passende
                    Stellenangebote per E-Mail vorschlagen dürfen, benötigen wir
                    nach den neuen Datenschutzrichtlinien Ihre Zustimmung.
                  </p>
                  <br />
                  <p>
                    <a
                      href="https://www.select-gmbh.de/datenschutz"
                      target="_blank"
                      >Zum Datenschutz</a
                    >
                  </p>
                  <br />
                  <p>
                    Wir freuen uns, wenn wir Sie auf dem Weg zu Ihrem
                    persönlichen Traumjob begleiten dürfen.
                  </p>
                </div>

                <div>
                  <DataInput
                    v-model="privacyPolicyAccepted"
                    required
                    type="bool"
                    class="w-full mt-4"
                    label="Datenschutz akzeptieren"
                    name="privacyPolicyAccepted"
                  />

                  <div class="vx-card__title">
                    <h4 class="pb-4 pt-8">
                      Verarbeitung von personenbezogenen Daten
                    </h4>
                    <p>
                      Hiermit willige ich ein, dass eine Verarbeitung meiner
                      personenbezogenen Daten (insbesondere Anschreiben,
                      Lebenslauf, Bewerberfragebogen, Bewerberinterviews,
                      Zeugnisse, Qualifikationen, Gesundheitsdaten, sonstige
                      Daten die im Bewerberverfahren mitgeteilt wurden) in
                      Übereinstimmung der DSGVO, BDSG (neue Fassung) und allen
                      weiteren geltenden Rechtsvorschriften durch die Select
                      GmbH erfolgen darf. Zweck der Verarbeitung ist die
                      Vermittlung in ein befristetes oder unbefristetes Arbeits-
                      oder Beschäftigungsverhältnis. Im Rahmen der Durchführung
                      der Dienstleistung der Select GmbH willige ich ein, dass
                      meine Bewerberdaten an Dritte (Kunden, Interessenten und
                      Master-Partner) zu dem oben genannten Zweck übermittelt
                      werden dürfen. Selbstverständlich erfolgt vor jeder
                      Übermittlung an Dritte ein Abgleich mit Ihnen. Außerdem
                      willige ich ein, dass die Select GmbH mich im Zuge des
                      Bewerberverfahrens kontaktieren darf, um mich auf
                      Stellenanzeigen aufmerksam zu machen oder um mir weitere
                      Informationen im Zuge der Dienstleistung zukommen zu
                      lassen. Ich willige ein, dass meine Daten ab Erteilung
                      dieser Einwilligung für 36 Monate gemäß den oben
                      beschriebenen Zwecken verarbeitet werden dürfen. Die
                      erteilte Einwilligung ist freiwillig und kann jederzeit
                      mit Wirkung auf Zukunft und ohne Angaben von Gründen
                      widerrufen werden. Der Widerruf kann an nachfolgende
                      Adresse gesendet werden: Select GmbH, Am Mantel 1, 76646
                      Bruchsal,
                      <a href="mailto:datenschutz@select-gmbh.de"
                        >datenschutz@select-gmbh.de</a
                      >
                    </p>
                  </div>

                  <DataInput
                    v-model="dataPolicyAccepted"
                    required
                    type="bool"
                    class="w-full mt-4"
                    label="Datenverarbeitung akzeptieren"
                    name="dataPolicyAccepted"
                  />

                  <vs-button
                    :disabled="!privacyPolicyAccepted || !dataPolicyAccepted"
                    class="mt-4"
                    @click="acceptPolicy"
                    >Absenden zum Bestätigen</vs-button
                  >
                </div>
              </form>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import DataInput from "@/components/ui/DataInput";

export default {
  components: {
    DataInput
  },
  data: () => ({
    privacyPolicyAccepted: null,
    dataPolicyAccepted: null
  }),
  methods: {
    acceptPolicy() {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($code: String!) {
              acceptApplicantPrivacyPolicy(code: $code)
            }
          `,
          variables: {
            code: this.$route.params.code
          }
        })
        .then(() => {
          this.$vs.notify({
            title: "Datenschutz",
            text:
              "Datenschutz erfolgreich zugestimmt. Sie werden gleich weitergeleitet.",
            color: "success",
            icon: "mail_outline",
            time: 4000,
            position: "bottom-center"
          });
          setTimeout(() => {
            window.location.href =
              "https://www.select-gmbh.de/datenschutz-akzeptiert";
          }, 4100);
          this.privacyPolicyAccepted = false;
        });
    }
  }
};
</script>
